<template>
  <div class="user-side">
    <div class="user-container">
      <div class="order-center">
        <h3>订单中心</h3>
        <ul>
          <li :class="{'active': $route.path === '/orderList'}"><router-link to="/orderList">我的订单</router-link></li>
          <li :class="{'active': $route.path === '/service'}"><router-link to="/service">售后列表</router-link></li>
          <!--          <li :class="{'active': $route.path === '/rate'}"><router-link to="/rate">评价管理</a></li>-->
        </ul>
      </div>
      <div class="user-center">
        <h3>用户中心</h3>
        <ul>
          <!--                <li :class="{'active': $route.path === '/sign'}"><router-link to="/sign">签到记录</a></li>-->
          <li :class="{'active': $route.path === '/collect'}"><router-link to="/collect">我的搜藏</router-link></li>
          <li :class="{'active': $route.path === '/history'}"><router-link to="/history">我的浏览</router-link></li>
        </ul>
      </div>
      <div class="account-center">
        <h3>账户中心</h3>
        <ul>
          <li :class="{'active': $route.path === '/profile'}"><router-link to="/profile">账户设置</router-link></li>
          <li :class="{'active': $route.path === '/message'}"><router-link to="/message">消息中心</router-link></li>
        </ul>
      </div>


    </div>
  </div>
</template>

<script>
export default {
  name: "Side",
  mounted() {
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss">
.user-side {
  margin-bottom: 40px;

  .highlight {
    color: #ff6600;
  }

  .user-container {

    background-color: #FFFFFF;
    width: 240px;
    height: 520px;

    display: flex;
    flex-direction: column;
    justify-content: center;

    .order-center, .user-center, .service-center, .account-center {
      margin-left: 50px;


      h3 {
        font-size: 16px;
        font-weight: 400;
        line-height: 52px;
        color: #333;
        margin: 0;
        padding: 0
      }

      ul {
        .active {
          a {
            color: #ff6600;
          }
        }

        li {
          padding: 6px 0;

          a {
            color: #757575;

          }
        }
      }

    }
  }
}
</style>